/**
 * RiseIn
 *
 * SHS Visual Experience System — Sprint 29.1A.
 *
 * Subtle vertical rise + fade entrance (translateY 8px → 0, opacity 0 → 1).
 *
 * Safety contract mirrors FadeIn:
 *   - Terminal state is opacity 1, transform none — the element's natural
 *     resting state. If the animation never runs, content stays visible
 *     and in position.
 *   - No layout shift outside the transform, which is composited and
 *     does not push neighbors around.
 *   - Reduced-motion: no animation class is applied; content renders in
 *     its final position and opacity.
 */

import React from 'react';
import { useMotionMode } from '../hooks/useMotionMode';

export const RiseIn = ({
  as: Tag = 'div',
  className = '',
  style,
  children,
  ...rest
}) => {
  const { isReduced } = useMotionMode();
  const animationClass = isReduced ? '' : 'motion-rise-in';
  const composed = [className, animationClass].filter(Boolean).join(' ');

  return (
    <Tag className={composed} style={style} {...rest}>
      {children}
    </Tag>
  );
};

export default RiseIn;
